import { DOMcreateElement, DOMcreateFragment } from '../typescript/TSXDomParse';
import NavMenu from './NavMenu';
export default function MainNav(data, isMobile) {
    if (isMobile === void 0) { isMobile = false; }
    return (DOMcreateElement(DOMcreateFragment, null, data.map(function (d) { return (DOMcreateElement(NavMenu, { isMobile: isMobile, data: d, level: 1 })); })));
}
